export const CommunityQueryKeys = {
  all: ['community'],
  details: () => [...CommunityQueryKeys.all, 'detail'],
  members: () => [...CommunityQueryKeys.all, 'member'],
  activities: () => [...CommunityQueryKeys.all, 'activity'],
  recommended: ['recommend'],
  detail: (id: number) => [...CommunityQueryKeys.details(), id],
  member: (id: number) => [...CommunityQueryKeys.members(), id],
  activity: (id: number) => [...CommunityQueryKeys.activities(), id],
  pagination: (page: number) => [...CommunityQueryKeys.all, 'pagination', page],
  infinite: () => [...CommunityQueryKeys.all, 'infinite'],
};
